import { useSearchParams } from 'react-router-dom';

export function useFilterQuery() {
  const [params, setParams] = useSearchParams();

  const get = (key: string) => params.getAll(key);

  const set = (key: string, value: string | string[]) => {
    const newParams = new URLSearchParams(params.toString());
    newParams.delete(key);

    const shouldRemove =
      (typeof value === 'string' && value.trim() === '') ||
      (Array.isArray(value) && value.length === 0);

    if (!shouldRemove) {
      if (Array.isArray(value)) {
        value.forEach(v => newParams.append(key, v));
      } else {
        newParams.set(key, value);
      }
    }

    setParams(newParams);
  };

  const clearAll = (keys: string[]) => {
    const newParams = new URLSearchParams(params.toString());

    keys.forEach(key => newParams.delete(key));

    setParams(newParams);
  };

  return { get, set, clearAll };
}
